<div class="menu-bar">
    <ot-menu-bar-wrapper (showMenuBar)="openMenu($event)"></ot-menu-bar-wrapper>
</div>